import { render, staticRenderFns } from "./capacitiesChart.vue?vue&type=template&id=a10239c6&"
import script from "./capacitiesChart.vue?vue&type=script&lang=js&"
export * from "./capacitiesChart.vue?vue&type=script&lang=js&"
import style0 from "./capacitiesChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports